import { createSlice } from "@reduxjs/toolkit";

export const dynamicFieldSlice = createSlice({
  name: "dynamicFieldDetails",
  initialState: { allDynamicField: {}, sectionDynamicFieldList: [] },
  reducers: {
    setDynamicSelectedValue: (state, action) => {
      console.log(action.payload);
      state.allDynamicField[action.payload.dynamicKey].value =
        action.payload.value;
      state.allDynamicField[action.payload.dynamicKey].op = "I";
    },
    setDynamicSelectedError: (state, action) => {
      console.log(action.payload);
      state.allDynamicField[action.payload.dynamicKey].errorDesc =
        action.payload.errorDesc;
    },
    setSectionDynamicFieldList: (state, action) => {
      state.sectionId = action.payload;
      state.sectionDynamicFieldList = Object.values(
        state.allDynamicField
      ).filter((d) => d.sectionId == action.payload)
        .sort((v1, v2) => (v1.orderNo || 999999) - (v2.orderNo || 999999));
    },
    setDynamicFieldList: (state, action) => {
      console.log("action.payload", action.payload);
      action.payload &&
        action.payload.forEach((df) => {
          if (!state.allDynamicField[df.dynamicKey]) {
            state.allDynamicField[df.dynamicKey] = {};
          }
          state.allDynamicField[df.dynamicKey] = {
            ...state.allDynamicField[df.dynamicKey],
            ...df,
          };
          try {
            state.allDynamicField[df.dynamicKey].possibleValues =
              (df.possibleValues && JSON.parse(df.possibleValues)) || [];
          } catch (e) {
            state.allDynamicField[df.dynamicKey].possibleValues = df.possibleValues && df.possibleValues.split(",");
            console.log(e);
          }
        });

      if (state.sectionId) {
        state.sectionDynamicFieldList = Object.values(
          state.allDynamicField
        ).filter((d) => d.sectionId == state.sectionId)
          .sort((v1, v2) => (v1.orderNo || 999999) - (v2.orderNo || 999999));
      }
    },

    // setDynamicFieldList: (state, action) => {
    //   console.log("action.payload", action.payload);
    //   action.payload &&
    //     action.payload.forEach((df) => {
    //       if (!state.allDynamicField[df.dynamicKey]) {
    //         state.allDynamicField[df.dynamicKey] = {};
    //       }
    //       state.allDynamicField[df.dynamicKey] = {
    //         ...state.allDynamicField[df.dynamicKey],
    //         ...df,
    //       };
    //       state.allDynamicField[df.dynamicKey].possibleValues =
    //         (df.possibleValues && JSON.parse(df.possibleValues)) || [];
    //     });

    //   if (state.sectionId) {
    //     state.sectionDynamicFieldList = Object.values(
    //       state.allDynamicField
    //     ).filter((d) => d.sectionId == state.sectionId);
    //   }
    // },
    resetDynamicData: (state, action) => {
      Object.keys(state.allDynamicField).forEach((k) => {
        state.allDynamicField[k].op = "N";
      });
    },
    setDynamicFieldData: (state, action) => {
      action.payload.forEach((d) => {
        if (!state.allDynamicField[d.dynamicKey]) {
          state.allDynamicField[d.dynamicKey] = {};
        }
        state.allDynamicField[d.dynamicKey].value = d.value;

        state.allDynamicField[d.dynamicKey].op = "N";
      });

      state.sectionDynamicFieldList = Object.values(
        state.allDynamicField
      ).filter((d) => d.sectionId == state.sectionId).sort((v1, v2) => (v1.orderNo || 999999) - (v2.orderNo || 999999));
    },
    clearDynamicData: (state, action) => {
      Object.keys(state.allDynamicField).forEach((k) => {
        state.allDynamicField[k].op = "N";
      });
    },
  },
});

export const {
  resetDynamicData,
  clearDynamicData,
  setDynamicFieldData,
  setDynamicFieldList,
  setDynamicSelectedValue,
  setDynamicSelectedError,
  setSectionDynamicFieldList,
} = dynamicFieldSlice.actions;

export default dynamicFieldSlice.reducer;
